import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ShirtIcon, ClockIcon, SparklesIcon } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: <CheckCircleIcon className="h-8 w-8 text-olive-500" strokeWidth={1.5} data-id="element-17" />,
    title: 'Blazers que realmente quedan bien',
    desc: 'No genéricos. No de talla única. Cortes pensados para el cuerpo de la mujer latina — con hombros que dan estructura, cintura que define, y telas que no se arrugan con el calor de Cali.'
  }, {
    icon: <ShirtIcon className="h-8 w-8 text-olive-500" strokeWidth={1.5} data-id="element-18" />,
    title: 'Camisas que complementan tu vida',
    desc: 'Para la reunión del lunes. Para el evento del viernes. Para el día que necesitas verte impecable sin parecer que intentaste demasiado.'
  }, {
    icon: <ClockIcon className="h-8 w-8 text-olive-500" strokeWidth={1.5} data-id="element-19" />,
    title: 'Una experiencia que respeta tu tiempo',
    desc: 'Nada de buscar entre miles de opciones confusas. Aquí encuentras lo que necesitas, rápido, con atención personalizada.'
  }, {
    icon: <SparklesIcon className="h-8 w-8 text-olive-500" strokeWidth={1.5} data-id="element-20" />,
    title: 'Asesoría de imagen incluida',
    desc: 'Porque la prenda correcta en el cuerpo incorrecto no funciona. Y la prenda correcta en el cuerpo correcto — cambia todo.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-14 bg-cream-50" data-id="element-21">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <div className="text-center mb-16" data-id="element-23">
          <h2 className="text-3xl md:text-4xl font-display text-charcoal mb-4" data-id="element-24">
            Lo que obtienes cuando entras
          </h2>
          <div className="w-16 h-px bg-terracotta-400 mx-auto" data-id="element-25"></div>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-26">
          {benefits.map((benefit, idx) => <motion.div key={idx} variants={itemVariants} className="bg-white p-8 shadow-sm border border-cream-100 hover:border-olive-200 transition-colors flex flex-col h-full" data-id="element-27">
              <div className="mb-6 bg-cream-50 w-16 h-16 flex items-center justify-center rounded-full" data-id="element-28">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-display text-charcoal mb-4" data-id="element-29">
                {benefit.title}
              </h3>
              <p className="text-charcoal/70 font-light leading-relaxed flex-grow" data-id="element-30">
                {benefit.desc}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}